<template>

    <div class="summary_field">
        <small v-if="this.initial && this.initial.prompt.length > 0" v-html="this.initial.prompt" />
        <br v-if="this.initial && this.initial.prompt.length > 0"/>
        <textarea v-if="!locked" v-model="item" placeholder="Type here"></textarea>
        <p v-if="locked" v-html="item"></p>
        <button v-if="removable" @click="remove()">Remove</button>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'SummaryField',
    props: {
        valueKey: String,
        initial: Object,
        removable: Boolean,
        locked: Boolean
    },
    data() {
        if (!this.initial) {
            return {
                item: ""
            }
        } else {
            return {
                item: this.initial.question
            }
        }
    },

    watch: {
        item: function(val) {
            this.setSummaryResponse({key: this.valueKey, value: val})
        }
    },

    computed: {
    },
    
    methods: {
        ...mapMutations(['setSummaryResponse']),

        remove() {

        },
    }
}
</script>

<style scoped>
  
</style>